import { ComponentProps, useEffect, useState } from "react";
import { TrimmedBreakingNewsArticle } from "@caas/types";
import Card from "@particles/card/Card";
import { getBreakingNewsCard } from "@routes/Section/components/BreakingNews/helpers/getBreakingNewsCard";
import axios from "axios";

const fetchTrimmedBreakingNews = async (): Promise<
  TrimmedBreakingNewsArticle[]
> => {
  try {
    const response = await axios.get("/_plat/api/v1/trimmed-breaking-news");

    return response.data;
  } catch (error) {
    return [];
  }
};

/**
 * Description: It returns trimmed breaking news list.
 * @returns data - {TrimmedBreakingNewsArticle[]}
 */
export const useTrimmedBreakingNews = (): ComponentProps<typeof Card>[] => {
  const [data, setData] = useState<ComponentProps<typeof Card>[]>([]);

  useEffect(() => {
    const callFetch = async () => {
      const props = getBreakingNewsCard(await fetchTrimmedBreakingNews());
      setData(props);
    };
    callFetch();
  }, []);

  return data;
};
